"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Transition = exports.Kind = void 0;
var _GlobalKind = _interopRequireDefault(require("../type-tools/GlobalKind"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Kind = exports.Kind = function (Kind) {
  Kind[Kind["CRITICAL"] = _GlobalKind["default"].CRITICAL] = "CRITICAL";
  Kind[Kind["WARNING"] = _GlobalKind["default"].WARNING] = "WARNING";
  Kind[Kind["POSITIVE"] = _GlobalKind["default"].POSITIVE] = "POSITIVE";
  Kind[Kind["DEFAULT"] = _GlobalKind["default"].DEFAULT] = "DEFAULT";
  Kind[Kind["INFORMATION"] = _GlobalKind["default"].INFORMATION] = "INFORMATION";
  return Kind;
}(Kind || {});
var Transition = exports.Transition = /*#__PURE__*/function (Transition) {
  Transition["SHOW"] = "show";
  Transition["HIDE"] = "hide";
  return Transition;
}(Transition || {});